import { render, staticRenderFns } from "./tagify.vue?vue&type=template&id=5b0e1e4c&"
import script from "./tagify.vue?vue&type=script&lang=js&"
export * from "./tagify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports